import { apiConfig } from '../../config/api.config'
import { environmentConfig } from '../../config/environment.config'

const IS_DEV = process.env.NODE_ENV === environmentConfig.development

export const API = {
  fetchDossierStatus: (idn: string) =>
    IS_DEV ? `${apiConfig.prefix}/dossiers/${idn}` : `${apiConfig.prefix}/dossiers/${idn}`,
}
